import React from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import Hero from '../components/sections/Hero';
import About from '../components/sections/About';
import Philosophy from '../components/sections/Philosophy';
import Services from '../components/sections/Services';
import Pricing from '../components/sections/Pricing';

function LandingPage() {
  return (
    <div className="min-h-screen bg-[#FAFAFA] text-stone-900 font-sans selection:bg-stone-200">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Philosophy />
        <Services />
        <Pricing />
      </main>
      <Footer />
    </div>
  );
}

export default LandingPage;